export const getTypeAuth = (type) => {
  if (type && type.match(/^([a-z]|\d)+$/) !== null) return type;

  return 'default';
};
